import { Button, Grid, Theme } from '@mui/material';
import GVImage from 'components/common/GVImage/GVImage';
import { GVTypography } from 'components/lib';
import { useNavigate } from 'react-router-dom';
import GVTooltip from 'components/lib/GVToolTip/GVTooltip';
import { GVIconText } from 'components/icons';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
  content: {
    flex: '1',
    maxHeight: '100%',
    overflow: 'hidden',
  },
  noLinkUnderline: {
    textDecoration: 'none',
  },
  textWrappingWidth: {
    width: '440px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  textSpacing: {
    marginTop: '8px',
  },
  buttonSpacing: {
    marginTop: '24px',
  },
  icon: {
    height: '30px',
    width: 'auto',
  },
  topSpacing: {
    padding: theme.spacing(1, 0),
    backgroundColor: 'var(--gds-color-cool-gray-900)',
  },
  centerText: {
    display: 'flex',
    textAlign: 'center',
  },
  subtitleMaxWidth: {
    width: '340px',
    margin: '0 auto',
    marginTop: 8,
  },
}));

const InspectionAccessDenied = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <Grid container direction="column">
      <Grid container direction="column" className={classes.topSpacing}>
        <GVTooltip title="Home" side="bottom">
          <GVIconText className={classes.icon} onClick={() => navigate('/')} />
        </GVTooltip>
      </Grid>
      <Grid item container justifyContent="center" className={classes.content}>
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          direction="column"
          className={`${classes.textWrappingWidth}`}
        >
          <GVImage alt="Access denied" src="/img/img-page-denied@2x.svg" />
          <GVTypography variant="h4" emphasis="high" className={classes.textSpacing}>
            You don't have access to this inspection
          </GVTypography>
          <GVTypography
            variant="subtitle1"
            emphasis="disabled"
            className={`${classes.textWrappingWidth} ${classes.textSpacing} ${classes.centerText} ${classes.subtitleMaxWidth}`}
          >
            If you believe you should have access, please contact the inspection owner to request permission.
          </GVTypography>
          <Button
            id="dialog-ok"
            color="secondary"
            variant="contained"
            className={classes.buttonSpacing}
            onClick={() => navigate('/')}
          >
            Back to Home
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InspectionAccessDenied;
